// Presentation constants. `CELL` is read from the atlas manifest at boot (11 §4.1) and
// defaults to the style gate's 24 px; the mock-board fixture overrides it to 32.

export interface AtlasManifest {
  cell: number;
  /** Phaser texture key → atlas base URL (without extension). */
  atlases: Record<string, string>;
  /** Role → { texture key, frame name, optional variant frames }. Roles are what the scene asks for; frames are what the art has. */
  roles: Record<string, RoleFrame>;
}

export interface RoleFrame { key: string; frame: string; variants?: string[] }

export const DEFAULT_CELL = 24;

/** Oryx atlases produced by the art pipeline (12) into public/assets/oryx. Frame names per picks.json; CELL per manifest.json. */
export const ORYX_PICKS_URL = '/assets/oryx/picks.json';
export const ORYX_MANIFEST_URL = '/assets/oryx/manifest.json';
export const ORYX_ATLAS_KEYS = ['creatures', 'world', 'tiles', 'items', 'fx24', 'fx32', 'classes'] as const;
/** Placeholder atlas of coloured squares (scripts/make-dev-atlas.mjs) used until the Oryx atlases land. */
export const DEV_MANIFEST_URL = '/assets/dev/manifest.json';

export const ROLES = [
  'floor', 'floor_alt', 'wall', 'water', 'door', 'exit', 'walkway',
  'hero_fighter', 'hero_wizard', 'hero_cleric', 'hero_ranger',
  'goblin', 'goblin_screener', 'goblin_javelin', 'goblin_skirmisher', 'hobb',
] as const;
export type Role = (typeof ROLES)[number];

export const BOARD_CAMERA_ZOOMS = [2, 3, 4] as const;
export type BoardZoom = (typeof BOARD_CAMERA_ZOOMS)[number];
/** docs/33 E5: the encounter camera's zoom range in CSS px per art px; stops between are whole device pixels. */
export const BOARD_ZOOM = { min: 1, max: 6 } as const;
